export const MIN_COLUMN_WIDTH = 120;
export const CELL_HEIGHT = 60;
